module.exports = __webpack_public_path__ + "static/media/Accuracy_Area_Light.c3819dab.svg";